import { FC } from 'react';
import { IoAdd } from 'react-icons/io5';

import { Box, Button } from '@mantine/core';

import { ComponentInstanceHelpers } from '@diagram/helpers/ComponentInstanceHelpers';

import { getComponentSectionFields } from 'models';
import { ComponentHelpers } from 'helpers/ComponentHelpers';

import { useDatasheetElectrical } from 'components/component-datasheet/hooks/use-datasheet-electrical';
import { useDatasheetPorts } from 'components/component-datasheet/hooks/use-datasheet-ports';
import { CapacityField } from 'components/component-fields/CapacityField';
import { ChargeField } from 'components/component-fields/ChargeField';
import { Datasheet } from 'components/datasheet/Datasheet';

import { useComponentContext } from '../../hooks/use-component-context';
import { ComponentDatasheetEfficiencyCurves } from '../ComponentDatasheetEfficiencyCurves';
import { ComponentDatasheetPort } from '../ComponentDatasheetPort.Team';
import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const Electrical: FC = () => {
    const { component } = useComponentContext();
    const { addPort } = useDatasheetPorts();
    const electrical = useDatasheetElectrical();

    const componentDefinition = ComponentInstanceHelpers.definition(component.type || 'custom');

    if (!componentDefinition || !ComponentHelpers.componentTypeHasElectrical(component.type)) {
        return null;
    }

    const electricalFields = getComponentSectionFields(component.type, 'electrical');

    return (
        <ComponentDatasheetSection title="Electrical">
            <Datasheet.Table header={{ prefix: ['Electrical'], label: 'General' }}>
                {'energyCapacity' in electricalFields && (
                    <Datasheet.TableRow name="electrical.energyCapacity" label="Energy Capacity">
                        <CapacityField name={`electrical.energyCapacity`} />
                    </Datasheet.TableRow>
                )}
                {'chargeCapacity' in electricalFields && (
                    <Datasheet.TableRow name="electrical.chargeCapacity" label="Charge Capacity">
                        <ChargeField name={`electrical.chargeCapacity`} />
                    </Datasheet.TableRow>
                )}
            </Datasheet.Table>
            {electrical.ports.map((port: any, index: number) => (
                <ComponentDatasheetPort index={index} label={`Port ${index + 1}`} key={`${index}-${port.id}`} />
            ))}
            {electrical.ports.length < componentDefinition.ports.max && (
                <Box mb="sm">
                    <Button onClick={() => addPort()} size="xs" leftSection={<IoAdd />}>
                        Add Port {electrical.ports.length + 1} Specifications
                    </Button>
                </Box>
            )}
            {'efficiency' in electricalFields && <ComponentDatasheetEfficiencyCurves />}
        </ComponentDatasheetSection>
    );
};

export { Electrical };
